export const SCROLL_THROTTLE_DELAY = 100;
export const RESIZE_THROTTLE_DELAY = 100;
export const DRAG_SCROLL_THROTTLE_DELAY = 100;
export const TABLE_SCROLL_BUTTON_DELAY = 300;
export const FAVORITE_DEBOUNCE_DELAY = 500;
